import { z } from "zod";

/**
 * Shared DTO — danh mục năng lực AI **ĐỌC** cho admin (US-AI-0322 · @UC9415 @UC9400).
 *
 * VÌ SAO TÁCH KHỎI `admin-ai-capabilities.ts`: file kia mô tả usecase **GHI** và khoá cứng
 * `tier: z.literal("write")` + có PATCH bật/tắt. Năng lực đọc là loài khác hẳn — READ-ONLY, LUÔN BẬT,
 * KHÔNG có đường ghi. Nhét chung vào một schema sẽ phải nới `tier` thành union và mở cửa cho một cờ
 * `enabled` lẻn vào danh mục đọc.
 *
 * BẤT BIẾN:
 * - **CHỈ ĐỌC**: không có body PATCH/POST nào trong file này, có chủ đích. QĐ PO 17/07
 *   (`read-tool-registry.ts:22-25`): năng lực đọc không toggle per-group — cầu dao duy nhất là
 *   `ai_enabled` per-group. Muốn đảo ⇒ HỎI PO, không thêm schema ghi ở đây.
 * - `tier: z.literal("read")` + `alwaysOn: z.literal(true)` ⇒ **trạng thái "năng lực đọc đã tắt"
 *   KHÔNG BIỂU DIỄN ĐƯỢC**. Mirror chiều ngược của `adminAiCapabilityItemSchema`.
 * - `.strict()` — chặn key lạ tại biên (C5 fail-closed input).
 * - Nguồn sự thật của DANH SÁCH là `READ_TOOL_REGISTRY` (domain). Contract chỉ mô tả HÌNH DẠNG,
 *   không bao giờ liệt kê tên tool.
 */

/** Một năng lực đọc: mã tool + mô tả (nguyên văn chuỗi LLM đọc) + điều kiện dùng. */
export const adminAiReadCapabilityItemSchema = z
  .object({
    /** Tên tool trong `READ_TOOL_REGISTRY` (= `QueryReportKind`), vd `member_list`. */
    toolName: z.string(),
    /** Mô tả NGUYÊN VĂN từ registry — admin đọc đúng chuỗi LLM đọc (hai bản = hai sự thật). */
    descriptionVi: z.string(),
    /** Luôn `read` — 0 bút toán, không confirm, không audit ghi tiền. */
    tier: z.literal("read"),
    /** Cần KỲ (YYYY-MM); thiếu ⇒ trợ lý HỎI LẠI chứ không đoán (AI-INV). */
    requiresPeriod: z.boolean(),
    /** Chọn được quỹ cụ thể (LLM chọn trong tập ĐÓNG server đã duyệt). */
    supportsFund: z.boolean(),
    /** LUÔN BẬT — literal `true` để trạng thái tắt không tồn tại trong hợp đồng. */
    alwaysOn: z.literal(true),
  })
  .strict();
export type AdminAiReadCapabilityItem = z.infer<typeof adminAiReadCapabilityItemSchema>;

/**
 * Response `GET /v1/admin/ai/read-capabilities`.
 *
 * KHÔNG có `groupId` — có chủ đích: danh mục đọc không phụ thuộc nhóm (không có override per-group).
 * Thêm `groupId` vào đây là ngầm hứa một sự kế thừa KHÔNG TỒN TẠI.
 */
export const adminAiReadCapabilitiesResponseSchema = z
  .object({
    items: z.array(adminAiReadCapabilityItemSchema),
  })
  .strict();
export type AdminAiReadCapabilitiesResponse = z.infer<
  typeof adminAiReadCapabilitiesResponseSchema
>;
